import type { MutableRefObject } from 'react';
import { plural } from '@frameio/i18n';
import { AlertDialog, AlertDialogButton } from '@frameio/vapor';
import TEXT from './generated/TEXT/WarningModal';

type WarningModalProps = {
  onDismiss: () => void;
  onDownload: () => void;
  onExit: () => void;
  dismissRef: MutableRefObject<null>;
  showWarning: boolean;
};

TEXT.DEFINE(
  {
    errorMessage: (count: number) =>
      plural(count, {
        one: `Couldn't download ${count} item`,
        other: `Couldn't download ${count} items`,
      }),
    warningMessage: 'Some files could not be downloaded.',
    downloadWarningContinue: 'Continue',
    downloadWarningDetails:
      'Folder structure will not be retained. All files will be downloaded individually.',
    downloadWarningDismiss: 'Dismiss',
    downloadWarningTitle: 'Continue with download?',
  },
  { plural }
);

/**
 * The WarningModal alerts a user that folders will be flattened
 * when files are downloaded in the browser.
 */
export const WarningModal = ({
  onDismiss,
  onDownload,
  onExit,
  dismissRef,
  showWarning,
}: WarningModalProps) => {
  return (
    <AlertDialog
      actions={
        <>
          <AlertDialogButton ref={dismissRef} onClick={onDismiss}>
            {TEXT.downloadWarningDismiss}
          </AlertDialogButton>
          <AlertDialogButton color="primary" onClick={onDownload}>
            {TEXT.downloadWarningContinue}
          </AlertDialogButton>
        </>
      }
      details={TEXT.downloadWarningDetails}
      hasOutermostTheme={true}
      isShowing={showWarning}
      leastDestructiveRef={dismissRef}
      onExited={onExit}
      title={TEXT.downloadWarningTitle}
      variant="notice"
    />
  );
};
